type ScrollBehavior = 'smooth' | 'auto';

export const scrollToTop = (value = 0, behavior: ScrollBehavior = 'smooth') =>
  window.scroll({
    behavior,
    top: value
  });

export const scrollToBottom = (screenHeight: number) =>
  window.scroll({
    top: screenHeight,
    behavior: 'smooth'
  });
